import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TestResultService } from '../../services/test-result.service';
import { TestAccession } from '../../models/TestAccession';
import { TestGroup } from '../../models/TestGroup';
import { ResultLine } from '../../models/ResultLine';
import { Source } from '../../models/Source';
import { AuthService } from '../../services/auth.service';
import { ResultListFilterComponent } from '../result-list-filter/result-list-filter.component';
import { ResultDetailsComponent } from '../result-details/result-details.component';
import { TooltipPosition } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { Test } from '../../models/Test';
//import { AnyAaaaRecord } from 'dns';

@Component({
  selector: 'app-result-list',
  standalone: true,
  imports: [CommonModule, ResultListFilterComponent, ResultDetailsComponent],
  templateUrl: './result-list.component.html',
  styleUrl: './result-list.component.css'
})

export class ResultListComponent implements OnInit {
  //@Output() onViewDetails = new EventEmitter<any>();
  UserSource: Source = new Source();
  TestAccessions: TestAccession[] = [];
  selectedTestAccession: TestAccession | undefined = undefined;
  //detailsHidden: boolean = false;
  currentPage: number = 1;
  searchCriteria: any;
  sortOrder: boolean = true;//true === ASC; false === DESC
  sortColumn: string = "";
  SourceFilterEnabled: boolean = false;
  FilterSources: string[] = [];
  constructor(private testResultSevice: TestResultService, private authService: AuthService) { }

  ngOnInit() {
    this.UserSource = this.authService.getLoginSource() || new Source();
  }

  onFilter(data : any) {
    console.log("onFilter received list", data);
    this.searchCriteria = data;
    this.loadTestRequests(data, "RequestDate", "ASC");
  }


  enableSourceFilter() {
    this.SourceFilterEnabled = true;
  }


  highLighted(testgroup: TestGroup) {
    let indx = testgroup.ResultLines.findIndex(res => res.Flag == 'High' || res.Flag == 'Low' || res.Flag == 'A')
    //console.log(testgroup,indx);
    return indx > -1;
  }

  flipSort(column: string) {
    //console.log("Search Criteria: ", this.searchCriteria);
    this.sortOrder = !this.sortOrder;
    this.sortColumn = column;
    this.SourceFilterEnabled = false;
    //TODO Extract items with sorting
    //console.log("Column: " + column);
    //console.log("SortType: " + this.sortOrder);
    this.loadTestRequests(this.searchCriteria, column, this.sortOrder ? "DESC" : "ASC");

    this.TestAccessions = this.TestAccessions.sort((a: { [index: string]: any }, b: { [index: string]: any }) => {
      switch (column) {
        case "RequestDate":
          return this.sortOrder ? new Date(a[column]).valueOf() - new Date(b[column]).valueOf() : new Date(b[column]).valueOf() - new Date(a[column]).valueOf();
        default:
          return this.sortOrder ? a[column].localeCompare(b[column]) : b[column].localeCompare(a[column]);
      }
      //return new Date(a.RequestDate).valueOf() - new Date(b.RequestDate).valueOf();
    });
  }

  chevronUp(col : string) {
    return this.sortColumn == col && this.sortOrder;
  }

  chevronDown(col : string) {
    return this.sortColumn == col && !this.sortOrder;
  }

  /*
  private loadTestRequests(searchCriteria) {
    this.testResultSevice.getTestResults(searchCriteria, this.currentPage).subscribe(data => this.TestAccessions = data);
  }
  */

  private onlyUnique(value :any, index : any, array : any) {
    return array.indexOf(value) === index;
  }

  private loadTestRequests(searchCriteria: any, sortBy: any, sortType : any) {
    this.testResultSevice.getTestResults(searchCriteria, sortBy, sortType, this.currentPage).subscribe(data => {
      this.TestAccessions = data;
      this.FilterSources = data.map(ta => ta.SourceCode).filter(this.onlyUnique);
    });
  }

  public onFilterSourceChange(src: any) {
    let filtersrc = src.target.value;
    this.testResultSevice.getTestResults(this.searchCriteria, "RequestDate", "ASC", this.currentPage).subscribe(data => {
      this.TestAccessions = data.filter(ta => ta.SourceCode === filtersrc);
    });
  }

  public hideDetails() {
    this.selectedTestAccession = undefined;
  }

  incrementPage() {
    this.currentPage += 1;
    //console.log("page = ", this.currentPage);
    this.loadTestRequests(this.searchCriteria, this.sortColumn, this.sortOrder ? "DESC" : "ASC");
  }

  decrementPage() {
    this.currentPage -= 1;
    //console.log("page = ", this.currentPage);
    this.loadTestRequests(this.searchCriteria, this.sortColumn, this.sortOrder ? "DESC" : "ASC");
  }

  viewDetails(testAccesion: TestAccession) {
    this.selectedTestAccession = testAccesion;
    window.scrollTo(0, 0);
  }
}
